import React, { Component } from 'react';

import Links from '../Tools/links';
import Carousel from '../Tools/Carousel';

const tempBandTitle = {
  maxWidth: '80%',
  margin: 'auto',
};

class BandHigh extends Component {
  state = {
    imageList: [
      {
        img: 'https://i.ytimg.com/vi/1fEj9l0wtbQ/maxresdefault.jpg',
        school: 'Duncanville High School',
      },
      {
        img:
          'https://parkcities.bubblelife.com/viewimage/key/359004450/highlander_band_awaits_awards_ka.jpg?w=655&h=655',
        school: 'Highland Park High School',
      },
    ],
  };

  render() {
    const { files } = this.props;

    return (
      <div className="band_high scroll">
        <h2 className="band_title">High School</h2>
        {/* <h3 style={tempBandTitle}>**UIL Region 5/20 Marching Contest - New Date and Site - November 17, 2020 at Midlothian ISD Stadium</h3> */}
        <Carousel imageList={this.state.imageList} />
        <div className="band_high_sub">
          <div className="band_high_btm">
            <div>
              <h3>Marching</h3>
              <Links input={files.marching} />
            </div>
            <div>
              <h3>Solo & Ensemble</h3>
              <Links input={files.solo} />
            </div>
            <div>
              <h3>Concert</h3>
              <Links input={files.concert} />
            </div>
          </div>
          <div className="border_line" />
          <div className="band_high_btm">
            <h3>Contest Schedules</h3>
            <Links input={[...files.schedules]} />
          </div>
        </div>
      </div>
    );
  }
}

export default BandHigh;



// WEBPACK FOOTER //
// ./src/Components/Band/BandHigh.js